import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/orders";

// Checkout: converts the active cart into an order.
// details: { customer_name, phone, shipping_address, note }
const checkout = (details) =>
  axios.post(API_URL, details, { headers: authHeader() });

// Current user's own orders.
const myOrders = () =>
  axios.get(`${API_URL}/my`, { headers: authHeader() });

// One order (owner or staff).
const get = (id) =>
  axios.get(`${API_URL}/${id}`, { headers: authHeader() });

// Owner cancels a still-pending order.
const cancel = (id) =>
  axios.post(`${API_URL}/${id}/cancel`, {}, { headers: authHeader() });

// --- Admin / moderator ---
// opts.silent: background refresh (no global loading bar).
const getAll = (params = {}, opts = {}) =>
  axios.get(API_URL, { params, headers: authHeader(), silent: !!opts.silent });

const updateStatus = (id, status) =>
  axios.put(`${API_URL}/${id}/status`, { status }, { headers: authHeader() });

const OrderService = { checkout, myOrders, get, cancel, getAll, updateStatus };

export default OrderService;
